<div [formGroup]="formGroup" class="pure-g">
  <!-- Damage Code -->
  <div class="pure-u-1 pure-u-md-1-3 p-r-8 p-b-16">
    <mc-input
      ngDefaultControl
      label="Damage Code"
      formControlName="damageCode"
      [disabled]="formGroup.get('damageCode')?.disabled ?? false"
      [attr.invalid]="isControlInErrorState(formGroup.controls['damageCode'])"
      fit="small"
      required
      oninput="this.value = this.value.toUpperCase()">
      @if (formGroup.get('damageCode')?.hasError('required')) {
        <span slot="errormessage">Damage Code is required</span>
      }
      @if (formGroup.get('damageCode')?.hasError('minlength') || formGroup.get('damageCode')?.hasError('maxlength')) {
        <span slot="errormessage">Damage Code must be exactly 2 characters</span>
      }
    </mc-input>
  </div>

  <!-- Description -->
  <div class="pure-u-1 pure-u-md-1-3 p-r-8 p-b-16">
    <mc-input
      ngDefaultControl
      label="Description"
      formControlName="description"
      [attr.invalid]="isControlInErrorState(formGroup.controls['description'])"
      fit="small"
      required>
      @if (formGroup.get('description')?.hasError('required')) {
        <span slot="errormessage">Description is required</span>
      } @else if (formGroup.get('description')?.hasError('maxlength')) {
        <span slot="errormessage">Description cannot exceed 200 characters</span>
      }
    </mc-input>
  </div>

  <!-- Damage type -->
  <div class="pure-u-1 pure-u-md-1-3 p-r-8 p-b-16">
    <mc-select
      ngDefaultControl
      label="Damage Type"
      formControlName="damageType"
      [attr.invalid]="isControlInErrorState(formGroup.controls['damageType'])"
      fit="small"
      required
      (optionselected)="onDamageTypeSelected($event)">
      @for (dt of damageTypeList; track dt.code) {
        <mc-option [attr.data-cy]="dt.code" [value]="dt.code">{{ dt.description }}</mc-option>
      }
      @if (formGroup.get('damageType')?.hasError('required')) {
        <span slot="errormessage">Damage Type is required</span>
      }
    </mc-select>
  </div>
</div>
